import React from 'react';

export type IconSvgProps = React.SVGProps<SVGSVGElement>;

const IconSvg = ({
  children,
  viewBox = '0 0 24 24',
  width = '1em',
  height = '1em',
  fill = 'currentColor',
  ...props
}: IconSvgProps & { children: React.ReactNode }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    width={width}
    height={height}
    fill={fill}
    aria-hidden
    focusable="false"
    {...props}
  >
    {children}
  </svg>
);

export default IconSvg;
